import { useQuery } from "react-query";

import http from "../../services/httpService";
import Util from "../../util/util";
import jwtDecode from "jwt-decode";
import useUrls from "../useUrls";

/**
 *
 * @param apiUrl
 * @returns {function(): Promise<*>}
 */
const getUserInfo = (apiUrl) => async () => {
  console.log("getUserInfo() called...");

  const config = Util.addTokenToHeaders();
  const { data } = await http.get(`${apiUrl}/users/info`, config);

  console.log("getUserInfo() response data:");
  console.log(data);
  return data;
};

export default function useQueryUserInfo() {
  const { apiUrl } = useUrls();

  let username = null;
  const token = localStorage.getItem("token");
  if (token) {
    const tokenObj = jwtDecode(token);
    username = tokenObj.username;
  }

  return useQuery(["userInfo", username], getUserInfo(apiUrl), {
    enabled: !!localStorage.getItem("token") && !!username,
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 60 * 1000,
  });
}
